import { profilesTypes } from '../constants/profilesConstants';

const loadFriends = (friends, invited, pending) => ({
    type: profilesTypes.LOAD_FRIENDS,
    friends,
    invited,
    pending
});

const loadProfiles = (profiles, profType='find') => ({
    type: profilesTypes.LOAD_FILTER,
    profiles,
    profType,
});

const setProfilesType = (profType='find') => ({
    type: profilesTypes.SET_PROFILE_TYPE,
    profType,
});

const setFilter = (filter, isFiltering) => ({
    type: profilesTypes.SET_FILTER,
    filter,
    isFiltering
});

const setMessage = (message, messageType) => ({
    type: profilesTypes.SET_MESSAGE,
    message,
    messageType
});

const setUpdateFriendlist = () => ({
    type: profilesTypes.UPDATE_FRIENDLIST,
});

const setDonate = (target, current, isPremium) => ({
    type: profilesTypes.SET_DONATE,
    donate: {target, current, isPremium},
});

export default {
    loadFriends,
    loadProfiles,
    setProfilesType,
    setFilter,
    setMessage,
    setUpdateFriendlist,
    setDonate
};